/**
 * The hidden container everything is printed from.
 *
 * Mounted once in the app shell. The print stylesheet hides the whole page
 * except `#print-root`, so whatever this renders is what comes out of the
 * printer - and nothing else does.
 *
 * Off screen rather than `display: none`, because a hidden element has no
 * layout and some browsers will print it blank. Positioning it far to the left
 * keeps it laid out and measurable while invisible.
 */

import { useEffect, useState } from 'react';
import { subscribe, getCurrentJob } from './printBus';
import Receipt from './Receipt';
import KitchenTicket from './KitchenTicket';
import ShiftReport from './ShiftReport';

const PrintRoot = () => {
    const [job, setJob] = useState(getCurrentJob());

    useEffect(() => subscribe(setJob), []);

    return (
        <div
            id="print-root"
            aria-hidden="true"
            className="pointer-events-none fixed left-[-9999px] top-0 bg-white"
        >
            {job?.type === 'receipt' && <Receipt receipt={job.data} />}
            {job?.type === 'kot' && <KitchenTicket ticket={job.data} />}
            {job?.type === 'shift' && (
                <ShiftReport report={job.data} countedCash={job.countedCash ?? null} />
            )}
        </div>
    );
};

export default PrintRoot;
